// extracted by mini-css-extract-plugin
export default {"label":"RadioButton_label__kwTZy","radio":"RadioButton_radio__QrSx8","children":"RadioButton_children__JhGxG"};